import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/api-service/api-service';

@Injectable()
export class ShelterClusterUserModalsDataService {
  constructor(private apiService: ApiService) {}

  public getShelterPortfolioGroupings(userId): Observable<any> {
    return this.apiService.getShelterClusterUserShelters(userId);
  }

  public getShelterClusterUserDetail({ userId }): Observable<any> {
    return this.apiService.getShelterClusterUserDetail({ userId });
  }
}
